import { Component, Prop, Vue } from 'vue-property-decorator';
@Component({ components: {} })
export default class SingleInputDialog extends Vue {
  @Prop() public placeholder!: string;
  @Prop({ default: '' }) public initialValue!: string;
  @Prop({ default: false }) public area!: boolean;
  @Prop() public label!: string;
  @Prop() public title!: string;
  @Prop() public handler!: (value: string) => void;

  public value: string = this.initialValue;

  public handleOk() {
    this.handler(this.value);
  }

  public show(): void {
    this.getDialog().show();
  }

  private getDialog() {
    return this.$refs.singleInputDialog as any;
  }
}
